import _ from 'lodash';
import React from 'react';
import { MdSave } from 'react-icons/md';
import Crud from '~/components/crud';
import { formats } from '~/helper';
import { PlaceForm, PlaceSchema } from '~/views/places/form';
import { Container } from '~/views/places/styles';
import CellStatus from '~/components/datatable/cell-status';
import usePlaces from '~/view-data/use-places';

const columns = [
  {
    name: '# Nome',
    selector: 'name',
    cell: (row) => {
      return (
        <CellStatus title={row.name} color={row.active ? '#53d449' : '#e6467f'}>
          <strong>{row.name}</strong>
        </CellStatus>
      );
    },
  },
  {
    name: 'Cadastrado em',
    selector: 'createdAt',
    hide: 'md',
    width: '140px',
    format: (row) => formats.dateTimeZone(_.get(row, 'createdAt'), 'dd/MM/yyyy HH:mm')
  },
];

function Places({ acls }) {
  const canWrite = acls.includes('W');
  const { state, actions } = usePlaces();

  return (
    <Container>
      <Crud
        columns={columns}
        emptyText='Nenhum local encontrado'
        data={state.data}
        hideAdd={!canWrite}
        tableLoading={state.loading}
        formLoading={state.formLoading}
        formTitle={(data) => (_.get(data, 'id')) ? `Local #${data.id}` : `Novo Local`}
        onChangePage={actions.pageChange}
        onRowClicked={actions.load}
        formOptions={{
          validationSchema: PlaceSchema,
          initialValues: state.model,
          initialTouched: { identify: true },
        }}
        renderForm={(args) => <PlaceForm {...args} previewMode={!canWrite} />}
        actions={[
          {
            label: 'Salvar',
            icon: MdSave,
            isSubmit: true,
            isDisabled: ({ isValid }) => !isValid || !canWrite,
            action: actions.createOrUpdate,
          },
        ]}
      />
    </Container>
  );
}

export default Places;
